import { render } from "./Profile.vue?vue&type=template&id=72615427&scoped=true"
const script = {}

import "./Profile.vue?vue&type=style&index=0&id=72615427&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-72615427"

export default script